import { Box, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTransferQueue } from "./app/transferQueue";
import { humanReadableSize } from "./app/utils";

function ActiveUploadProgress() {
  const transferQueue = useTransferQueue();

  const activeTask = useMemo(() => {
    const uploadTasks = transferQueue.filter((task) => task.type === "upload");
    return (
      uploadTasks.find((task) => task.status === "in-progress") ??
      uploadTasks.find((task) => task.status === "pending") ??
      null
    );
  }, [transferQueue]);

  if (!activeTask) return null;

  const { name, loaded, total, status } = activeTask;
  const progress = total ? Math.min((loaded / total) * 100, 100) : 0;

  return (
    <Box
      sx={{
        position: "fixed",
        left: "50%",
        bottom: { xs: 72, sm: 32 },
        transform: "translateX(-50%)",
        width: "min(560px, 90%)",
        zIndex: (theme) => theme.zIndex.tooltip,
      }}
    >
      <Paper elevation={6} sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Typography variant="body2" fontWeight={500} noWrap>
            {status === "pending" ? "Preparando carga" : "Subiendo archivo"}: {name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {humanReadableSize(loaded)} / {humanReadableSize(total)}
          </Typography>
          <LinearProgress
            variant={status === "pending" ? "indeterminate" : "determinate"}
            value={status === "pending" ? undefined : progress}
          />
        </Stack>
      </Paper>
    </Box>
  );
}

export default ActiveUploadProgress;
